import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    if (
      error.response?.status === 401 &&
      !original._retry &&
      !original.url.includes("/auth/")
    ) {
      original._retry = true;
      try {
        await axios.post(`${API}/auth/refresh`, {}, { withCredentials: true });
        return api(original);
      } catch (e) {
        // refresh failed, fall through
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(error) {
  const detail = error?.response?.data?.detail;
  if (detail == null) return error?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const SERVICES = [
  { id: "suits", name: "Bespoke & Made-to-Measure Suit", time: "60 min consultation" },
  { id: "sport-coats", name: "Custom Sport Coat / Blazer", time: "45 min consultation" },
  { id: "shirts-pants", name: "Custom Shirts & Trousers", time: "30 min consultation" },
  { id: "wedding", name: "Wedding Suit Consultation", time: "90 min consultation" },
  { id: "tuxedos", name: "Tuxedo & Black Tie", time: "60 min consultation" },
  { id: "wardrobe", name: "Full Wardrobe Consultation", time: "60 min consultation" },
];

export const FABRICS = [
  "Loro Piana",
  "Ermenegildo Zegna",
  "Holland & Sherry",
  "Drago",
  "Dormeuil",
  "Ariston",
  "Fratelli Tallia di Delfino",
  "Albini",
  "Alumo",
  "Canclini",
  "Thomas Mason",
  "Open to guidance",
];

export const LOCATIONS = ["Atelier Studio", "My Home", "My Office", "My Hotel"];

export function prettyTime(t) {
  const [h, m] = t.split(":").map(Number);
  const ampm = h >= 12 ? "PM" : "AM";
  const hr = h % 12 === 0 ? 12 : h % 12;
  return `${hr}:${String(m).padStart(2, "0")} ${ampm}`;
}

const TRACKING_KEY = "bm_tracking";

export function initTracking() {
  try {
    const existing = JSON.parse(localStorage.getItem(TRACKING_KEY) || "null");
    if (existing && (existing.utm_source || existing.referrer)) return;
    const p = new URLSearchParams(window.location.search);
    const t = {
      referrer: document.referrer || "",
      utm_source: p.get("utm_source") || p.get("ref") || "",
      utm_medium: p.get("utm_medium") || "",
      utm_campaign: p.get("utm_campaign") || "",
      landing_page: window.location.pathname,
    };
    if (!existing || t.utm_source || t.referrer) localStorage.setItem(TRACKING_KEY, JSON.stringify(t));
  } catch (e) {}
}

export function getTracking() {
  try {
    return JSON.parse(localStorage.getItem(TRACKING_KEY)) || {};
  } catch (e) {
    return {};
  }
}
